import { EmailValidationStrings } from 'utils/strings';
import * as yup from 'yup';

export const emailSchema = yup.object().shape({
  email: yup
    .string()
    .matches(/[^$]/, EmailValidationStrings.empty)
    .matches(/@/, EmailValidationStrings.missingAT)
    .matches(/@+\S/, EmailValidationStrings.missingDomain)
    .matches(/^\S+@+/, EmailValidationStrings.missingPrefix)
    .matches(/^[^@]*@[^+@]*$/, EmailValidationStrings.specialinDomain)
    .matches(/^([^@]*@){1}[^@]*$/, EmailValidationStrings.doubleATs)
    .matches(/^[^.].*$/, EmailValidationStrings.startsWithDot)
    .matches(
      /^(?!.*[!#$%^&*()_\-=[\]{};':"\\|,<>/?]).*$/,
      EmailValidationStrings.specials
    )
    .matches(
      /^(?!.*[!@#$%^&*()_\-=[\]{};':"\\|,.<>/?]{2}).*$/,
      EmailValidationStrings.multipleSpecials
    )
    // eslint-disable-next-line no-control-regex
    .matches(/^[\x00-\x7F]*$/, EmailValidationStrings.nonAscii)
    .matches(
      /@+([a-zA-Z\-0-9])+\.+([a-zA-Z\-0-9])/,
      EmailValidationStrings.missingTopLevelDomain
    )
    .matches(
      /@+([a-zA-Z\-0-9])+\.+([a-zA-Z\-0-9]{2,})/,
      EmailValidationStrings.topLevelDomain
    )
    .required('Wymagane!'),
});
